import React from 'react';
import { MapPinIcon, NavigationIcon } from 'lucide-react';
import type { TourEntry } from '../../types/showcase';
import { entryDirectionsUrl } from '../../utils/maps';
interface TourEntryDetailsProps {
  entry: TourEntry;
}
export function TourEntryDetails({
  entry
}: TourEntryDetailsProps) {
  const closed = entry.status === 'closed';
  return <div data-id="element-174" data-mp="lqtwoi6bp6ot">
      <div className="flex items-start gap-3" data-id="element-175" data-mp="lqk5wsdgevi2">
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold text-white ${closed ? 'bg-muted' : 'bg-orange-deep'}`} aria-hidden="true" data-id="element-176" data-mp="6ys0b83govtj">
          {entry.number}
        </span>
        <div className="min-w-0" data-id="element-177" data-mp="2xg8cvx47yi6">
          <p className="font-display text-lg font-semibold uppercase leading-tight text-ink" data-id="element-178" data-mp="2yre31a4fgbx">{entry.model}</p>
          <p className="text-sm font-medium text-navy" data-id="element-179" data-mp="3k74rab16omb6">{entry.builder}</p>
        </div>
      </div>
      <p className="mt-3 flex gap-1.5 text-sm text-muted" data-id="element-180" data-mp="3p4oazqgnhrai">
        <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-181" data-mp="1r6b9pgaaaqgf" />
        {entry.address}, {entry.city}
      </p>
      {entry.note && <p className={`mt-2 rounded-md px-2.5 py-1.5 text-xs font-semibold ${closed ? 'bg-canvas text-muted' : 'bg-orange-light text-orange-deeper'}`} data-id="element-182" data-mp="1ma47nyl0dz3r">
          {entry.note}
        </p>}
      <a href={entryDirectionsUrl(entry)} target="_blank" rel="noreferrer" className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-navy px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-navy-dark" data-id="element-183" data-mp="18g3edkctt4as">
        <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="1chopb05sv8ic" />
        Get directions in Google Maps
      </a>
    </div>;
}